import { getDictInfoByCode } from '@/api/dict'
export default {
  state: {
    dictList: {}
  },
  getters: {
    dictList: state => state.dictList
  },
  mutations: {
    dictList (state, data) {
      state.dictList = data
    }
  },
  actions: {
    handleDictList (dictList, data) {
      dictList.commit('dictList', data)
    },
    getDictInfoByCode ({ commit }, code) {
      return new Promise((resolve, reject) => {
        getDictInfoByCode({ pCode: code }).then(response => {
          const result = response.data
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
